import Seo from "../components/Seo";
import { COMPANY } from "../lib/data";

function LegalLayout({ title, children }) {
  return (
    <div>
      <section className="bg-vegetal-800 text-white">
        <div className="max-w-4xl mx-auto px-5 md:px-10 py-14 md:py-16">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        </div>
      </section>
      <article className="max-w-4xl mx-auto px-5 md:px-10 py-14 md:py-20 prose-legal">
        <div className="space-y-8 text-neutral-700 leading-relaxed [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-neutral-900 [&_h2]:mb-3 [&_p]:mt-2">
          {children}
        </div>
      </article>
    </div>
  );
}

export function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales">
      <Seo title="Mentions légales — Carnier Toiture et Habitat" description="Mentions légales de Carnier Toiture et Habitat, artisan couvreur dans l'Oise." />
      <section>
        <h2>Éditeur du site</h2>
        <p>Le présent site est édité par <strong>{COMPANY.name}</strong>, entreprise artisanale spécialisée dans la rénovation, l'entretien et l'amélioration de l'habitat.</p>
        <p>Téléphone : {COMPANY.phone}</p>
        <p>E-mail : {COMPANY.email}</p>
        <p>Zone d'activité : Oise (60), Île-de-France et Picardie.</p>
        <p><em>Les informations légales complètes (raison sociale, SIRET, adresse du siège, numéro de TVA, responsable de publication, assurance décennale) seront ajoutées prochainement.</em></p>
      </section>
      <section>
        <h2>Hébergement</h2>
        <p>Ce site est hébergé par un prestataire d'hébergement web. Les coordonnées de l'hébergeur seront précisées ici.</p>
      </section>
      <section>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus présents sur ce site (textes, images, logo, mise en page) est protégé par le droit d'auteur. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.</p>
      </section>
      <section>
        <h2>Responsabilité</h2>
        <p>{COMPANY.name} s'efforce d'assurer l'exactitude des informations diffusées sur ce site mais ne saurait être tenue responsable des erreurs, omissions ou d'une indisponibilité temporaire du service.</p>
      </section>
      <section>
        <h2>Données personnelles</h2>
        <p>Le traitement des données personnelles collectées via les formulaires est décrit dans notre <a href="/politique-confidentialite" className="text-terracotta-600 underline">politique de confidentialité</a>.</p>
      </section>
    </LegalLayout>
  );
}

export function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité">
      <Seo title="Politique de confidentialité — Carnier Toiture et Habitat" description="Politique de confidentialité et gestion des données personnelles (RGPD) de Carnier Toiture et Habitat." />
      <section>
        <h2>Responsable du traitement</h2>
        <p><strong>{COMPANY.name}</strong> est responsable du traitement des données personnelles collectées sur ce site. Pour toute question, vous pouvez nous joindre au {COMPANY.phone} ou par e-mail à {COMPANY.email}.</p>
      </section>
      <section>
        <h2>Données collectées</h2>
        <p>Nous collectons uniquement les données que vous nous transmettez via nos formulaires (demande de devis, rappel, contact) : nom, téléphone, e-mail, code postal, type de demande, message, et éventuellement une photo de chantier.</p>
      </section>
      <section>
        <h2>Finalité du traitement</h2>
        <p>Ces données sont utilisées exclusivement pour répondre à votre demande, établir un devis et vous recontacter. Elles ne sont ni cédées, ni vendues, ni utilisées à des fins commerciales tierces.</p>
      </section>
      <section>
        <h2>Durée de conservation</h2>
        <p>Vos données sont conservées le temps nécessaire au traitement de votre demande et à la relation commerciale, puis supprimées ou archivées conformément à la réglementation.</p>
      </section>
      <section>
        <h2>Vos droits (RGPD)</h2>
        <p>Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition sur vos données. Pour exercer ces droits, contactez-nous au {COMPANY.phone} ou à {COMPANY.email}.</p>
      </section>
      <section>
        <h2>Cookies</h2>
        <p>Ce site utilise uniquement les cookies techniques nécessaires à son bon fonctionnement. Aucun cookie publicitaire n'est déposé sans votre consentement.</p>
      </section>
    </LegalLayout>
  );
}
